export const ReportAttendanceOperatorDetailText = {
  titleText: 'Absensi',
  breadcrumbTitleText: 'Absensi Report',
  buttonExportText: 'Export',
};

export const tabOptions = [
  { type: 'restViolation', label: 'Istirahat' },
  { type: 'cameraViolation', label: 'Pelanggaran' },
];
